import { ApplyOnAmazonStatus } from "../../../../types/history"
import { targetType } from "../../../../types/target"

export enum HistoryActionType {
  FETCH_SPONSORED_PRODUCTS_CAMPAIGNS = "HISTORY_SP/FETCH_SPONSORED_PRODUCTS",
  FETCH_SPONSORED_PRODUCTS_CAMPAIGNS_SUCCESS = "HISTORY_SP/FETCH_SPONSORED_PRODUCTS_SUCCESS",
  FETCH_SPONSORED_PRODUCTS_CAMPAIGNS_ERROR = "HISTORY_SP/FETCH_SPONSORED_PRODUCTS_ERROR",
}

interface FetchSponsoredProducts {
  type: HistoryActionType.FETCH_SPONSORED_PRODUCTS_CAMPAIGNS
}

interface FetchSponsoredProductsSuccess {
  type: HistoryActionType.FETCH_SPONSORED_PRODUCTS_CAMPAIGNS_SUCCESS
  payload: IHistory[]
}

interface FetchSponsoredProductsError {
  type: HistoryActionType.FETCH_SPONSORED_PRODUCTS_CAMPAIGNS_ERROR
  payload: string
}

export type HistoryAction =
  | FetchSponsoredProducts
  | FetchSponsoredProductsSuccess
  | FetchSponsoredProductsError

export interface IHistory {
  _id: string
  targetId: string
  targetType: targetType
  campaignName?: string
  targetName: string
  profileId: number
  newBid: number
  oldBid: number
  status: ApplyOnAmazonStatus
  createdAt: string
}

export interface IHistoryState {
  history: IHistory[]
  loading: boolean
  error: string | null
}
